/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S14_P2Inputs */

const tr_kullanim_s14_p2 = /** @type {(inputs: Kullanim_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Askıya alma süresi en fazla 30 (otuz) gün olup, bu süre içinde ihlal giderilmezse Sözleşme tek taraflı feshedilebilir. Askıya alma kararı Kullanıcı'nın kayıtlı e-posta adresine gerekçesi ile birlikte bildirilir; Kullanıcı bildirim tarihinden itibaren 7 iş günü içinde itiraz hakkına sahiptir.`)
};

const en_kullanim_s14_p2 = /** @type {(inputs: Kullanim_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The suspension period is at most 30 (thirty) days; if the breach is not remedied within this period, the Agreement may be terminated unilaterally. The suspension decision is notified together with its grounds to the User's registered email address; the User has the right to object within 7 business days from the date of notification.`)
};

const de_kullanim_s14_p2 = /** @type {(inputs: Kullanim_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sperrdauer beträgt höchstens 30 (dreißig) Tage; wird der Verstoß innerhalb dieser Frist nicht behoben, kann der Vertrag einseitig gekündigt werden. Die Sperrentscheidung wird zusammen mit ihrer Begründung an die registrierte E-Mail-Adresse des Nutzers mitgeteilt; der Nutzer hat ab dem Datum der Mitteilung 7 Werktage lang das Recht, Widerspruch einzulegen.`)
};

const ru_kullanim_s14_p2 = /** @type {(inputs: Kullanim_S14_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок приостановления составляет не более 30 (тридцати) дней; если нарушение не устранено в этот срок, Договор может быть расторгнут в одностороннем порядке. Решение о приостановлении вместе с его обоснованием направляется на зарегистрированный адрес электронной почты Пользователя; Пользователь вправе подать возражение в течение 7 рабочих дней с даты уведомления.`)
};

/**
* | output |
* | --- |
* | "The suspension period is at most 30 (thirty) days; if the breach is not remedied within this period, the Agreement may be terminated unilaterally. The suspen..." |
*
* @param {Kullanim_S14_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s14_p2 = /** @type {((inputs?: Kullanim_S14_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S14_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s14_p2(inputs)
	if (locale === "de") return de_kullanim_s14_p2(inputs)
	if (locale === "ru") return ru_kullanim_s14_p2(inputs)
	return tr_kullanim_s14_p2(inputs)
});